<template>
  <v-container :class="[darkUi === true ? 'dark' : 'light']" class="pa-0 ma-0" fluid>
    <!-- Add / edit offer dialog -->
    <v-dialog v-model="dialogs.addOffer" persistent fullscreen>
      <add-offer
        @close="dialogs.addOffer = !dialogs.addOffer"
        @save="dialogs.addOffer = !dialogs.addOffer"
        :editOffer="offer"
      ></add-offer>
    </v-dialog>

    <!-- Offer info dialog -->
    <v-dialog v-model="dialogs.info" width="50%">
      <more-info @close="dialogs.info = !dialogs.info" :offerInfo="offer"></more-info>
    </v-dialog>

    <!-- Delete all alert -->
    <v-dialog v-model="alerts.delete" width="30%" overlay-opacity="0">
      <v-alert border="left" type="error">
        <div style="display: flex; justify-content: space-between">
          <span>Delete all?</span>
          <div>
            <v-btn text @click="deleteAll(offer)">Yes</v-btn>
            <v-btn text @click="alerts.delete = !alerts.delete">No</v-btn>
          </div>
        </div>
      </v-alert>
    </v-dialog>

    <div :class="[darkUi === false ? 'light-mode-banner' : 'dark-mode-banner']">
      <div style="width: 100%;">
        <div style="display: flex; justify-content: space-between;">
          <v-btn depressed small @click="close">Back</v-btn>
          <v-btn text color="grey" @click="darkUi = !darkUi">
            <font-awesome-icon icon="moon" />
          </v-btn>
          <v-expansion-panels v-if="user" :dark="darkUi" tile style="width: 200px;">
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ user.name }}
                <template v-slot:actions>
                  <v-icon color="primary">$expand</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-btn text tile style="border: 1px solid #3F51B5">Logout</v-btn>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <h1
          class="mt-4"
          :class="[
            darkUi === true ? 'banner-title-dark' : 'banner-title-light'
          ]"
        >Your offers</h1>
      </div>
    </div>

    <!-- Search -->
    <div :class="[darkUi === true ? 'search-dark' : 'search-light']">
      <v-row>
        <v-col cols="7">
          <v-text-field outlined dense flat solo v-model="searchOffer">
            <template v-slot:prepend-inner>
              <font-awesome-icon icon="search" />
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-select dense outlined solo flat label="Sort by" v-model="sortType" :items="sortType"></v-select>
        </v-col>
        <v-col cols="2">
          <!-- Refresh -->
          <v-btn text tile class="control-btn info" width="100%" @click="refresh()">Refresh</v-btn>
        </v-col>
      </v-row>
    </div>
    <!-- Tools -->

    <div class="controls">
      <div></div>
      <div>
        <!-- Remove all -->
        <v-btn
          :disabled="addedOffers.length == 0"
          fab
          small
          text
          class="control-btn"
          :class="[darkUi === true ? 'delete-dark' : 'delete-light']"
          @click="alerts.delete = !alerts.delete"
        >
          <font-awesome-icon icon="trash" />
        </v-btn>
      </div>
    </div>
    <div v-if="addedOffers.length > 0" style="display: flex; flex-direction: row; ">
      <div style="width: 30%; margin-left: 20px; text-align: center;">
        <div class="mb-5">
          <v-chip v-if="checkedOffers.length > 0" color="#dbdbdb">
            <v-btn text @click="deleteChecked()">Remove {{ checkedOffers.length }} offers</v-btn>
          </v-chip>
        </div>
        <v-expansion-panels focusable :dark="darkUi">
          <v-expansion-panel v-for="(offer, index) in addedOffers" :key="index" tile>
            <v-expansion-panel-header
              class="pa-0 ma-0"
              style="height: 70px;"
              @click="showOffer(offer)"
            >
              <v-row>
                <v-col cols="10" class="ma-2">
                  <h2 class="h2">{{ offer.merchant.name }}</h2>
                </v-col>
                <v-col>
                  <v-checkbox v-model="checkedOffers" :value="offer" class="ma-0 pa-0"></v-checkbox>
                </v-col>
              </v-row>
              <template v-slot:actions>
                <v-icon color="primary"></v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-btn
                text
                small
                @click="editOffer(offer)"
                class="my-4 info"
                style="width: 100%;"
              >Edit</v-btn>
              <v-divider />
              <div>
                <v-row>
                  <v-col class="pa-0 ma-0">
                    <v-row>
                      <v-col>
                        <h2 class="h2">Offer title</h2>
                        {{ offer.title }}
                      </v-col>
                    </v-row>
                    <v-divider />

                    <v-row>
                      <v-col>
                        <h2 class="h2">Start</h2>
                        {{ moment(offer.start).format("DD-MM-YYYY") }}
                        <br />
                        <h3>
                          {{ offer.dates[0].startDate.split(" ")[4] }}
                          {{ offer.dates[0].startDate.split(" ")[5] }}
                        </h3>
                      </v-col>
                      <v-col class="py-9">
                        <h1>-</h1>
                      </v-col>
                      <v-col>
                        <h2 class="h2">End</h2>
                        {{ moment(offer.finish).format("DD-MM-YYYY") }}
                        <br />
                        <h3>
                          {{ offer.dates[0].endDate.split(" ")[4] }}
                          {{ offer.dates[0].endDate.split(" ")[5] }}
                        </h3>
                      </v-col>
                    </v-row>

                    <v-divider />
                    <v-row>
                      <v-col>
                        <h2 class="h2">Category</h2>
                        {{ offer.category }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-divider />
              </div>
              <div style="width: 100%;">
                <v-btn text fab small @click="deleteOffer(offer)" style="width: 100%;">
                  <span style="color: red;">Delete offer</span>
                </v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Add new -->
        <v-btn tile class="info control-btn mt-6" @click="addOffer()">Add new offer</v-btn>
      </div>
      <div style="width: 70%; height: 1000px; margin: 0 20px 0 20px;">
        <offer-location
          :offer="offer"
          :disableUI="disabled"
          :darkUi="darkUi"
          style="border-radius: 20px;"
        ></offer-location>
      </div>
    </div>
    <div v-else>No offers to show!</div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import addOffer from "@/components/offer/addOffer";
import offerLocation from "@/components/offer/offerLocation";
import moment from "moment";

export default {
  components: {
    addOffer,
    offerLocation
  },
  data() {
    return {
      searchOffer: "",
      addedOffers: [],
      offer: {},
      dialogs: {
        offer: false,
        addOffer: false
      },

      disabled: false,

      // Alerts
      alerts: {
        delete: false
      },

      checkedOffers: [],

      darkUi: false,

      sortType: ["Most recent", "Oldest"]
    };
  },

  methods: {
    ...mapActions({
      findOffer: "offers/searchOffer",
      removeOffer: "offers/deleteOffer",
      deleteAll: "offers/deleteOffer",
      deleteOne: "offers/deleteOffer"
    }),

    showOffer(offer) {
      this.offer = offer;
    },

    close() {
      this.$emit("close");
    },

    getOffers() {
      this.addedOffers = this.offers.ownOffers;
    },

    addOffer() {
      this.dialogs.addOffer = !this.dialogs.addOffer;
    },

    editOffer(offer) {
      // assign full offer object to backend offer object
      let fullObjs = this.fullOfferObjs;
      let matchOffer = fullObjs.find(fullOffer => {
        return offer.id === fullOffer.id;
      });
      this.offer = matchOffer;
      this.dialogs.addOffer = !this.dialogs.addOffer;
    },

    deleteAll() {
      this.addedOffers.forEach(offer => {
        this.removeOffer(offer);
        this.getOffers();
        this.alerts.delete = false;
      });
    },

    deleteOffer(offer) {
      this.deleteOne(offer);
      this.dialogs.offer = !this.dialogs.offer;
      this.getOffers();
    },

    deleteChecked() {
      this.checkedOffers.forEach(offer => {
        this.deleteOne(offer);
      });
      this.checkedOffers = [];
      this.getOffers();
    },

    showInfo(offer) {
      this.dialogs.info = !this.dialogs.info;
      this.offer = offer;
    }
  },

  computed: {
    ...mapState({
      offers: state => state.offers,
      fullOfferObjs: state => state.editOffers,
      auth: state => state.auth
    }),

    user() {
      return this.auth.user;
    },

    fullOfferObjs() {
      return this.offers.editOffers;
    }
  },

  watch: {
    sortType(val) {
      if (val === "Most recent") {
        for (let i = 0; i <= this.addedOffers.length; i++) {
          if (this.addedOffers[i].start > this.addedOffers[i + 1].start) {
            this.addedOffers[i + 1] = this.addedOffers[i];
          }
        }
      }
    }
  },

  mounted() {
    this.getOffers();
    this.offer = this.addedOffers[0];
  }
};
</script>

<style lang="scss" scoped>
.dark {
  overflow: hidden;
  background-color: #666666;
  height: 100%;
}

.light {
  overflow: hidden;
  background-color: #f7f7f7;
  height: 100%;
}

.light-mode-banner {
  display: flex;
  justify-content: space-between;
  background-color: #f7f7f7;
  border-bottom: 1px solid #fff;
  box-shadow: 3px 5px 20px #dbdbdb;

  .banner-title-light {
    color: #3f51b5;
    font-size: 70px;
    font-weight: 100;
    margin-left: 20px;
  }
}

.dark-mode-banner {
  display: flex;
  justify-content: space-between;
  background-color: #333;
  border-bottom: 1px solid rgb(29, 29, 29);
  box-shadow: 3px 5px 20px #dbdbdb;

  .banner-title-dark {
    color: #ffffff;
    font-size: 70px;
    font-weight: 100;
    margin-left: 20px;
  }
}

.search-dark {
  height: 70px;
  padding: 0 30px 0 30px;
  background-color: #333;
  box-shadow: 3px 5px 20px #131313;
}

.search-light {
  height: 70px;
  padding: 0 30px 0 30px;
  background-color: #f3f3f3;
  box-shadow: 3px 5px 20px #dbdbdb;
}

.controls {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px;

  .control-btn {
    margin: 0 20px 8px 0;
  }
}

.delete-dark {
  border: 1px solid #fff;
  color: #fff;
}

.delete-light {
  border: 1px solid red;
  color: red;
}

.headings {
  color: #fff;
  box-shadow: 3px 5px 20px #dbdbdb;
}

.h2 {
  font-weight: 300;
}
</style>
